import React from "react"
import Icon from "../Icon/Icon"
import {FeatureItem} from "./types"
import classNames from "classnames"

interface FeatureItemCardProps extends FeatureItem {
	className?: string
}

export function FeatureItemCard({icon, title, description, note, className}: FeatureItemCardProps) {
	return (
		<div className={classNames("feature-item-card", className)}>
			<div className="feature-item-card-header">
				<Icon icon={icon} size="20" />
				<div className="feature-item-card-title">{title}</div>
			</div>
			<div className="feature-item-card-description">
				{description}
				{note && <sup className="feature-item-card-note">{note.id}</sup>}
			</div>
		</div>
	)
}
